import { useId } from "react";
import ExecutionItemCard from "./ExecutionItemCard";
import { deriveGroupRounds, orderGroupItems } from "../domain/groupRounds";

export { deriveGroupRounds, orderGroupItems };

function groupLabel(block) {
  if (block?.blockType === "SUPERSET") return "Superset";
  if (block?.blockType === "GIANT_SET") return "Giant set";
  if (block?.blockType === "CIRCUIT") return "Circuit";
  return "Grouped set";
}

export default function SupersetExecutionGroup({ block, items, ...props }) {
  const headingId = useId();
  const orderedItems = orderGroupItems(items);
  const rounds = deriveGroupRounds(props.record, orderedItems);
  // A round held only by skipped lanes is not a blocker, but nothing was
  // performed in it, so it is not presented as a completed round.
  const completedRounds = rounds
    .filter((round) => round.complete && round.actionableCount > 0).length;
  const label = groupLabel(block);
  const laneSummary = orderedItems.map((_, index) => `A${index + 1}`).join(" · ");
  const relationshipSummary = laneSummary
    ? `Alternating Sets (${laneSummary})`
    : "Alternating Sets";
  const roundSummary = rounds.length === 0
    ? `${orderedItems.length} ${orderedItems.length === 1 ? "exercise" : "exercises"}`
    : completedRounds > 0
      ? `${completedRounds} of ${rounds.length} rounds complete`
      : `${rounds.length} ${rounds.length === 1 ? "round" : "rounds"}`;

  return (
    <section
      className="lz-workout-group"
      data-block-key={block.blockKey}
      data-round-count={rounds.length}
      aria-labelledby={headingId}
    >
      <header className="lz-workout-group__header">
        <h2 id={headingId} className="lz-workout-group__badge">{label}</h2>
        <p className="lz-workout-group__meta">
          <span>{relationshipSummary}</span>
          <span className="lz-workout-group__rounds">{roundSummary}</span>
        </p>
      </header>
      <div className="lz-workout-group__rail">
        {orderedItems.map((item, index) => {
          const laneLabel = `A${index + 1}`;
          return (
            <div
              key={item.itemId}
              className="lz-workout-group__lane"
              data-lane={laneLabel}
              role="group"
              aria-label={`${laneLabel}, ${item.exerciseName || "Exercise"}`}
            >
              <ExecutionItemCard item={item} laneLabel={laneLabel} {...props} />
            </div>
          );
        })}
      </div>
    </section>
  );
}
